<template>
  <BittsContainer class="mcp-usage-stat-card">
    <p class="text-neutral-text-weak text-sm">{{ label }}</p>
    <p class="mcp-usage-stat-card__value">
      {{ displayValue }}
    </p>
    <BittsCallout
      v-if="isCallout"
      size="x-small"
      type="warning"
      :title="caption"
    />
    <p v-else class="text-neutral-text-weak text-sm mt-8">
      {{ caption }}
    </p>
  </BittsContainer>
</template>

<script setup lang="ts">
import { BittsCallout, BittsContainer } from '@crossbeam/bitts';

import { computed } from 'vue';

const { value } = defineProps<{
  label: string;
  value: number | null | undefined;
  caption: string;
  isCallout?: boolean;
}>();

const displayValue = computed(() =>
  value == null
    ? '--'
    : value.toLocaleString(undefined, { maximumFractionDigits: 0 }),
);
</script>
<style scoped lang="pcss">
@reference "../../css/theme.css";
.mcp-usage-stat-card {
  @apply flex flex-col h-full;
}
.mcp-usage-stat-card__value {
  @apply text-neutral-text-strong font-bold text-xxl mt-8 truncate;
}
</style>
